<!------------------------------------------------------------------------------
  - Copyright (c) 2024. dnote.ai
  -
  - @project DNOTE.AI-Frontend
  - @author dnote.ai
  - @copyright Dnote.ai All rights reserved
  ----------------------------------------------------------------------------->

<template>
	<div class="d-block position-relative">
		<SuperDashboardHome/>
	</div>
</template>
<script>
import SuperDashboardHome from "@/dashboard/stats/SuperDashboardHome.vue";
export default {
	name: "dashboard-default",
	data() {
		return {
		};
	},
	components: {
		SuperDashboardHome,
	},
};
</script>
